import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {ResultadoRegra} from '../resultado-regra';

@Component({
    template: `

  `,
    selector: 'app-resultado-regra-detalhe'
})
export class ResultadoRegraDetalheComponent implements OnInit {

    constructor(public dialog: MatDialog) {
    }

    ngOnInit() {
    }

    openInfoDialog(resultado: ResultadoRegra) {
        this.dialog.open(ResultadoRegraInfoDialogComponent, {
            data: resultado.mensagem,
            width: '800px'
        });
    }
}

@Component({
    selector: 'resultado-regra-detalhe',
    templateUrl: 'resultado-regra-detalhe.html'
})
export class ResultadoRegraInfoDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: string) {
    }
}

